export function parseLatestMetrics(allMetrics, siteId) {
  const relevantKeys = new Set([
    "A01_Q01", "A12_Q01", "A13_Q01", "A14_Q01", "A14_Q04", "A15_Q05"
  ]);

  const latestMetrics = {};
  for (const entry of allMetrics) {
    if (entry.site_id !== siteId) continue;
    const key = `${entry.node}_${entry.quant}`;
    if (!relevantKeys.has(key)) continue;

    const existing = latestMetrics[key];
    if (!existing || new Date(entry.time) > new Date(existing.time)) {
      latestMetrics[key] = entry;
    }
  }

  const structured = {};
  for (const metric of Object.values(latestMetrics)) {
    if (!structured[metric.node]) structured[metric.node] = {};
    structured[metric.node][metric.quant] = {
      value: metric.measured_value,
      time: metric.time,
    };
  }

  return structured;
}